import { useNavigate, useSearchParams } from 'react-router';
import { AlertCircle, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription } from '@/components/ui/alert';

function GoogleErrorPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Compute error message directly from search params
  const error = searchParams.get('error');
  const message = searchParams.get('message');

  let errorMessage = 'An error occurred during Google login.';

  if (error === 'google_auth_failed') {
    errorMessage = 'Google authentication failed. Please try again.';
  } else if (error === 'access_denied') {
    errorMessage =
      'Google login was cancelled. Please try again if you want to sign in.';
  } else if (message) {
    errorMessage = decodeURIComponent(message);
  }

  const handleReturnToLogin = () => {
    navigate('/login', { replace: true });
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow-sm sm:rounded-lg sm:px-10">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
              <AlertCircle className="h-6 w-6 text-red-600" />
            </div>
            <h2 className="mt-6 text-center text-2xl font-semibold text-gray-900">
              Google Login Failed
            </h2>
            <div className="mt-6">
              <Alert variant="destructive">
                <AlertCircle className="h-4 w-4" />
                <AlertDescription>{errorMessage}</AlertDescription>
              </Alert>
            </div>
            <div className="mt-6">
              <Button
                onClick={handleReturnToLogin}
                className="w-full flex items-center justify-center"
              >
                <ArrowLeft className="mr-2 h-4 w-4" />
                Back to Login
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GoogleErrorPage;
